import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import $helpers from "@/assets/js/helpers.js";
const FileSaver = require("file-saver");

const state = {
  forms: null,
  currentForm: null,
  formSubmissions: null,
  currentFormSubmission: null,
  projectFormSubmissions: null,
  currentProjectFormSubmission: null,
  currentFormSubmissionsProjects: null,
  currentFormSubmissionsClients: null,
};

const getters = {
  forms_get_forms: (state) => {
    return state.forms;
  },
  forms_get_current_form: (state) => {
    return state.currentForm;
  },
  forms_get_form_submissions: (state) => {
    return state.formSubmissions;
  },
  forms_get_current_form_submission: (state) => {
    return state.currentFormSubmission;
  },
  forms_get_project_form_submissions: (state) => {
    return state.projectFormSubmissions;
  },
  forms_get_current_project_form_submission: (state) => {
    return state.currentProjectFormSubmission;
  },
  forms_get_current_form_submissions_projects: (state) => {
    return state.currentFormSubmissionsProjects;
  },
  forms_get_current_form_submissions_clients: (state) => {
    return state.currentFormSubmissionsClients;
  },
};

const mutations = {
  FORMS_SET_FORMS(state, forms) {
    state.forms = forms;
  },
  FORMS_SET_CURRENT_FORM(state, form) {
    state.currentForm = form;
  },
  FORMS_SET_FORM_SUBMISSIONS(state, formSubmissions) {
    state.formSubmissions = formSubmissions;
  },
  FORMS_RESET_FORM_SUBMISSIONS(state) {
    state.formSubmissions = null;
  },
  FORMS_SET_CURRENT_FORM_SUBMISSION(state, submission) {
    state.currentFormSubmission = submission;
    state.currentFormSubmission.fields = submission.fields.sort((a, b) => {
      return $helpers.compare(a.field.order, b.field.order);
    });
  },
  FORMS_SET_PROJECT_FORM_SUBMISSIONS(state, formSubmissions) {
    state.projectFormSubmissions = formSubmissions;
  },
  FORMS_SET_CURRENT_PROJECT_FORM_SUBMISSION(state, submission) {
    state.currentProjectFormSubmission = submission;
    state.currentProjectFormSubmission.fields = submission.fields.sort((a, b) => {
      return $helpers.compare(a.field.order, b.field.order);
    });
  },
  FORMS_RESET_CURRENT_PROJECT_FORM_SUBMISSION(state) {
    state.currentProjectFormSubmission = null;
  },
  FORMS_SET_CURRENT_FORM_SUBMISSIONS_PROJECTS(state, projects) {
    state.currentFormSubmissionsProjects = projects;
  },
  FORMS_SET_CURRENT_FORM_SUBMISSIONS_CLIENTS(state, clients) {
    state.currentFormSubmissionsClients = clients;
  },
};

const actions = {
  getForms({ commit, dispatch, rootState }, payload = { customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.params.project ? payload.params.project : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFormFieldsetsGet(params)
            .then((res) => {
              console.log("teamFormFieldsetsGet", res.data.data);
              commit("FORMS_SET_FORMS", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getForm({ commit, dispatch, rootState }, payload = { customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        formFieldset: payload.formFieldset,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFormFieldsetsFormFieldsetGet(params)
            .then((res) => {
              console.log("teamFormFieldsetsFormFieldsetGet", res.data.data);
              commit("FORMS_SET_CURRENT_FORM", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getFormSubmissions({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        formFieldset: payload.formFieldset,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "created_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        client:
          typeof payload.params.client !== "undefined" && payload.params.client !== null ? payload.params.client : "",
        project:
          typeof payload.params.project !== "undefined" && payload.params.project !== null
            ? payload.params.project
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFormFieldsetsFormFieldsetResponsesGet(params)
            .then((res) => {
              console.log("teamFormFieldsetsFormFieldsetResponsesGet", res.data.data);
              commit("FORMS_SET_FORM_SUBMISSIONS", res.data.data);
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "formSubmissions",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  search: params.search,
                  filter: {
                    client: params.client,
                    project: params.project,
                  },
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getFormSubmission({ commit, dispatch, rootState }, payload = { customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFormFieldsetsFormFieldsetResponsesFormResponseGet(params)
            .then((res) => {
              console.log("teamFormFieldsetsFormFieldsetResponsesFormResponseGet", res.data.data);
              commit("FORMS_SET_CURRENT_FORM_SUBMISSION", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectFormSubmissions({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "created_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        client:
          typeof payload.params.client !== "undefined" && payload.params.client !== null ? payload.params.client : "",
        fieldset:
          typeof payload.params.fieldset !== "undefined" && payload.params.fieldset !== null
            ? payload.params.fieldset
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFormResponsesGet(params)
            .then((res) => {
              console.log("teamProjectsProjectFormResponsesGet", res.data.data);
              commit("FORMS_SET_PROJECT_FORM_SUBMISSIONS", res.data.data);
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "projectFormSubmissions",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  search: params.search,
                  filter: {
                    client: params.client,
                    fieldset: params.fieldset,
                  },
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectFormSubmission({ commit, dispatch, rootState }, payload = { customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFormResponsesFormResponseGet(params)
            .then((res) => {
              console.log("teamProjectsProjectFormResponsesFormResponseGet", res.data.data);
              commit("FORMS_SET_CURRENT_PROJECT_FORM_SUBMISSION", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteProjectFormSubmission({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFormResponsesFormResponseDelete(params)
            .then((res) => {
              console.log("teamProjectsProjectFormResponsesFormResponseDelete", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getFormSubmissionsProjects({ commit, dispatch, rootState }, payload = { customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFormFieldsetsFormFieldsetResponsesProjectsGet(params)
            .then((res) => {
              console.log("teamFormFieldsetsFormFieldsetResponsesProjectsGet", res.data.data);
              commit("FORMS_SET_CURRENT_FORM_SUBMISSIONS_PROJECTS", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getFormSubmissionsClients({ commit, dispatch, rootState }, payload = { customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFormFieldsetsFormFieldsetResponsesClientsGet(params)
            .then((res) => {
              console.log("teamFormFieldsetsFormFieldsetResponsesClientsGet", res.data.data);
              commit("FORMS_SET_CURRENT_FORM_SUBMISSIONS_CLIENTS", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  exportFormResponses({ commit, dispatch, rootState }, payload = { customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFormFieldsetsFormFieldsetResponsesExportGet(params)
            .then((res) => {
              const blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              FileSaver.saveAs(blob, payload.name + ".xlsx");
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
